import { Link } from 'react-router';

interface DeleteBlockedNoticeProps {
  /** "API key" or "switch" */
  noun: string;
  /** The resource's Numbers tab, linked as "View attached numbers". */
  numbersHref: string;
}

/** Shown in place of a delete action while numbers are still attached. */
export const DeleteBlockedNotice = ({ noun, numbersHref }: DeleteBlockedNoticeProps) => (
  <div
    role="status"
    className="flex gap-3 items-start px-4 py-3 text-sm rounded-md border text-amber-700 dark:text-amber-400 border-amber-300 dark:border-amber-600 bg-amber-50 dark:bg-amber-900/20"
  >
    <span className="material-symbols-outlined">block</span>
    <p>
      This {noun} still has numbers attached. Move them to another {noun} before deleting it.{' '}
      <Link to={numbersHref} className="underline">
        View attached numbers
      </Link>
    </p>
  </div>
);
